<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="false">
    <p style="color: white">Loading...</p>
</ngx-spinner>

<div class="text-center">
    <img *ngIf="loading[1]" src="./assets/images/loading04.gif" style="width: 10rem;">
</div>

<div class="content-wrapper" style="min-height: 307px">
    <div class="col-lg-12" *ngIf="userdata.userlevel !== '15'">
        <div class="card bg-primary">
            <div class="card-header">ระบบขอเงินส่งเสริมออนไลน์ {{year[3]}}
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                        <i class="fas fa-minus"></i>
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="card" style="color: black">
                    <div class="card-body">
                        <div class="row justify-content-md-center">
                            <div class="col-lg-5">
                                <!--
                                    <div class="input-group mb-3" *ngIf="famerlist != null">
                                        <span class="input-group-text">เลือกชาวไร่</span>
                                        <input type="text" class="form-control" list="farmer"
                                            placeholder="โควตา 10 หลัก" id="codefm" (change)="goloaddata()" />
                                        <datalist id="farmer">
                                            <option *ngFor="let item of famerlist">
                                                {{ item.fmcode_b1 }} {{ item.fmname }}_{{ item.cnt }}_แปลง_โซน-{{
                                                item.SUPZONE }}                                                
                                                <lable *ngIf="item.approve=='Y'">เบิกได้
                                                </lable>
                                                <lable *ngIf="item.PromiseIN==0">สัญญายังไม่ผ่าน</lable>
                                                <lable *ngIf="item.zoneban=='Y'">อยู่โซนต้องห้าม</lable>
                                            </option>
                                        </datalist>
                                        
                                        <div class="input-group-append">
                                            <button class="btn btn-default float-right"
                                                (click)="clearFm();">กรอกใหม่</button>
                                        </div>
                                    </div>-->

                                <mat-form-field appearance="fill">
                                    <mat-label>เลือกชาวไร่</mat-label>
                                    <mat-select required [(ngModel)]="fmcode" (ngModelChange)="goloaddata()"
                                        [disabled]="famerlist2.length==0">
                                        <mat-form-field class="example-form-field" appearance="fill">
                                            <mat-label>ค้นหา -*เลือกชาวไร่*-</mat-label>
                                            <input matInput type="text" [(ngModel)]="txtFindIn" focus
                                                (input)="onFilterChange($event.target.value)">
                                            <button *ngIf="txtFindIn" matSuffix mat-icon-button aria-label="Clear"
                                                (click)="txtFindIn='';onFilterChange('')"><mat-icon>close</mat-icon></button>
                                        </mat-form-field>
                                        <mat-option *ngFor="let item of famerlist; let i = index;" [value]="item">
                                            {{i+1}}.[{{ item.fmcode_b1 }}]-{{ item.fmname }}, {{ item.cnt }} แปลง,
                                            โซน-{{ item.SUPZONE }}
                                            <lable *ngIf="item.approve=='Y'">เบิกได้</lable>
                                            <lable *ngIf="item.PromiseIN==0">สัญญายังไม่ผ่าน</lable>
                                            <lable *ngIf="item.zoneban=='Y'">อยู่โซนต้องห้าม</lable>
                                        </mat-option>
                                        <mat-option *ngIf="famerlist.length==0" [value]=""
                                            disabled>.--ไม่พบข้อมูล--.</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-progress-bar *ngIf="loading[0]" mode="indeterminate"></mat-progress-bar>
                            </div>

                            <div class="col-md-auto">
                                <button mat-stroked-button color="accent" (click)="clearFm();">กรอกใหม่</button>
                                <mat-slide-toggle *ngIf="enabled[0]" [(ngModel)]="enabled[1]">enabled</mat-slide-toggle>
                            </div>

                            <div class="row justify-content-md-center" *ngIf="fmcode.fmcode">
                                <div class="col-md-8">
                                    <table style="width:100%">
                                        <tr style="text-align:center">
                                            <th>วงเงินตามหลักทรัพย์</th>
                                            <th>ยอดหนี้ค้าง </th>
                                            <th>วงเงินที่ใช้ไป</th>
                                            <th>ขอเงินส่งเสริมแล้ว </th>
                                            <th>ขอเบิกปัจจัยแล้ว</th>
                                            <th>วงเงินคงเหลือ</th>
                                            <th>วงเงินชั่วคราวใช้ไป/คงเหลือ</th>
                                        </tr>
                                        <tr style="text-align:center">
                                            <td>{{credit| number}}</td>
                                            <td>{{RSUM_long| number}}</td>
                                            <td>{{sum_money_amt| number}}</td>
                                            <td>{{sum_money_amt1| number}}</td>
                                            <td>{{sum_money_amt2| number}}</td>
                                            <td style="color: red;">{{limit| number}}</td>
                                            <td>{{sum_money_temp| number}}/{{money_temp_left| number}}</td>
                                        </tr>
                                    </table>
                                    <hr />

                                    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                        <li class="nav-item">
                                            <a class="nav-link" [ngClass]="{'active':tab_s == 1}" id="pills-1"
                                                data-toggle="pill" role="tab" aria-selected="true"
                                                (click)="tab_s=1">ข้อมูลแปลงปี {{year[2]}}
                                                <span class="badge badge-warning">{{dataonefarmer.length}}</span></a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" [ngClass]="{'active':tab_s == 2}" id="pills-2"
                                                *ngIf="fmcode!=''" data-toggle="pill" role="tab" aria-selected="true"
                                                (click)="tab_s=2">คำขอจากชาวไร่
                                                <span class="badge badge-warning">{{fm_factor.length}}</span></a>
                                        </li>
                                    </ul>

                                    <!--<div class="card-header">ข้อมูลแปลงปี {{year[2]}}</div>
                                        <p *ngFor="let item of canget">
                                          วงเงินทั้งหมด :
                                          {{ item.sumlimit.toLocaleString() }} วงเงินที่ขอแล้ว :
                                          {{ item.money_amt.toLocaleString() }} วงเงินคงเหลือ :
                                          {{ item.leftlimit.toLocaleString() }}
                                        </p>-->
                                    <div class="card">
                                        <div class="card-body table-responsive p-2" [ngSwitch]="tab_s"
                                            style="height: 500px">
                                            <table class="table table-hover table-head-fixed text-nowrap"
                                                *ngSwitchCase="2">
                                                <thead>
                                                    <tr class="headText text-primary" style="text-align:center">
                                                        <th>เลขที่</th>
                                                        <th>วันที่</th>
                                                        <th>ชื่อ</th>
                                                        <th>แปลง</th>
                                                        <th>เหตุผล</th>
                                                        <th>จำนวนเงิน</th>
                                                        <th>สถานะ</th>
                                                        <!--<td><i class="fas fa-print"></i> พิมพ์</td>-->
                                                        <th><i class="fas fa-ban"></i> Action </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let item of fm_factor; let i = index;"
                                                        style="text-align:center">
                                                        <td>{{ item.docid }}</td>
                                                        <td>{{ date2th(item.datepost) }}</td>
                                                        <td>{{ item.fmname }}</td>
                                                        <td>{{ item.intlandno }}</td>
                                                        <td>{{ item.comment_fm }}</td>
                                                        <td>{{ item.money_amt | number }}</td>
                                                        <td>{{ item.docdesc }}</td>
                                                        <td>
                                                            <button type="button" class="btn btn-outline-danger btn-sm"
                                                                (click)="cancledoc_id(item)">
                                                                <i class="fas fa-ban"></i>
                                                            </button> .
                                                            <button type="button" class="btn btn-outline-success btn-sm"
                                                                (click)="snaponedata(item,2)">
                                                                <i class="fa fa-arrow-circle-right"></i>
                                                            </button>
                                                        </td>

                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table *ngSwitchCase="1" #tb_data
                                                class="table table-hover table-head-fixed text-nowrap">
                                                <thead>
                                                    <tr class="headText text-primary" style="text-align:center">
                                                        <th>.</th>
                                                        <th>เลขแปลง</th>
                                                        <th>โซน</th>
                                                        <th>นสส.</th>
                                                        <th>ประเภท</th>
                                                        <th>กรรมสิทธิ์</th>
                                                        <th>พื้นที่</th>
                                                        <th>ปลูกเสร็จ</th>
                                                        <th>ค่าเช่า/คงเหลือ</th>
                                                        <th>ระยะสั้น/คงเหลือ</th>
                                                        <th>เลือก</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let item of dataonefarmer; let i = index;"
                                                        style="text-align:center"
                                                        [ngClass]="{'table-primary':sel_landno.itid == item.itid}">
                                                        <td>{{ i+1 }}</td>
                                                        <td>{{ item.intlandno }}</td>
                                                        <td>{{ item.supzone }}</td>
                                                        <td>{{ item.supcode }}</td>
                                                        <td>{{ item.CaneTypeName }}</td>
                                                        <td>
                                                            <b *ngIf="item.Plottype == '1'">ตนเอง</b>
                                                            <b *ngIf="item.Plottype == '2'">เช่า</b>
                                                        </td>
                                                        <td style="text-align:right">
                                                            {{ item.landvalue_left | number:'1.2-2' }}
                                                        </td>
                                                        <td>{{ item.PlantDate | adtob}}</td>
                                                        <td style="text-align:center">
                                                            {{ item.rental_limit | number }}
                                                            /{{ item.balance_rent |number }}
                                                        </td>
                                                        <td style="text-align:center">
                                                            {{ item.credit_amount | number }}
                                                            /{{ item.balance_limit | number }}
                                                        </td>
                                                        <td>
                                                            <button class="btn btn-outline-success btn-sm"
                                                                (click)="snaponedata(item);">
                                                                <i class="fa fa-arrow-circle-right"></i></button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <!-- ฟอร์มขอเบิกสินเชื่อ -->
                                <div class="col-md-4" [hidden]="ckfarmer">
                                    <div class="card" *ngIf="dataonefarmer.length>0">
                                        <div class="card-header bg-warning">
                                            ฟอร์มขอเบิกเงินส่งเสริมปี {{year[2]}} [ <label id="fmnamelable"></label> ]
                                        </div>
                                        <div class="card-body">
                                            <input type="text" class="form-control" id="plantnum"
                                                placeholder="หมายเลขแปลง" disabled />
                                            <br />
                                            <div class="row align-items-center" *ngIf="sel_landno.itid != null">
                                                <div class="col">
                                                    <div *ngFor="let item1 of subtype0">
                                                        <button type="button" class="btn btn-outline-primary btn-block"
                                                            [ngClass]="{'active':typeSL[0] == item1.l_id}"
                                                            name="subtype0" (click)="SubTypeSelectM(item1.l_id)"
                                                            [hidden]="(sel_landno.Plottype == 1 && item1.l_id=='e')
                                                            ||(sel_landno.main_category_id=='1' && (item1.l_id=='g'))
                                                            ||(sel_landno.main_category_id=='2' && (item1.l_id=='f'))">
                                                            {{item1.doc}}
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="col" *ngIf="type_e[0]==2">
                                                    <a class="btn btn-light btn-block disabled">เลือก รายการ </a>
                                                    <div *ngFor="let item2 of subtype1[0]">
                                                        <button type="button" class="btn btn-outline-success btn-block"
                                                            [ngClass]="{'disabled':
                                                            (sel_landno.Plottype == 1 && item2.l_id=='e')
                                                            ||(sel_landno.main_category_id==1 && (item2.id=='a2'))
                                                            ||(sel_landno.main_category_id==2 && (item2.id=='a1'))
                                                            ,'active':typeSL[1] == item2.id}" name="subtype1"
                                                            (click)="SubTypeSelectS(item2)">
                                                            {{item2.doc}}
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="col" *ngIf="type_e[0]==1">
                                                    <div class="col-md" *ngIf="type_e[1]==1">
                                                        <a class="btn btn-light btn-block disabled">เลือก รายการ </a>
                                                        <button type="button" class="btn btn-outline-success btn-block"
                                                            (click)="type_e[1]=2;type_e[2]=1">BRR MODEL เต็มรูปแบบ
                                                        </button>
                                                        <button type="button" class="btn btn-outline-success btn-block"
                                                            (click)="type_e[1]=2;type_e[2]=0">กิจกรรมแปลงตามแผนชาวไร่
                                                        </button>
                                                    </div>

                                                    <div class="col-md" *ngIf="type_e[1]==2">
                                                        <div *ngFor="let item2 of subtype1[type_e[2]]">
                                                            <mat-checkbox [value]="item2" [(ngModel)]="item2.select"
                                                                [disabled]="(sel_landno.main_category_id==1 && item2.l_id=='g')
                                                            ||(sel_landno.main_category_id==2 && item2.l_id=='f')
                                                            ||(sel_landno.ckNew!=0 && item2.id=='f11')
                                                            " (change)="filterSubType()">
                                                                {{item2.doc}}
                                                            </mat-checkbox>
                                                        </div>
                                                        <ul class="list-group list-group-numbered"
                                                            *ngIf="typeSL[0]=='f'&&type_e[2]==1">
                                                            <li class="list-group-item">ปรับพื้นที่</li>
                                                            <li class="list-group-item">ระเบิดดินดาน</li>
                                                            <li class="list-group-item">ระยะร่อง =>1.6 เมตร</li>
                                                            <li class="list-group-item">พันธุ์อ้อยสะอาด </li>
                                                            <li class="list-group-item">ใส่อินทรีย์ + โดโลไมท์</li>
                                                            <li class="list-group-item">ฉีดยาคุมแห้ง </li>
                                                            <li class="list-group-item">ปุ๋ยเคมีตามความต้องการของอ้อย
                                                            </li>
                                                        </ul>
                                                        <ul class="list-group list-group-numbered"
                                                            *ngIf="typeSL[0]=='g'&&type_e[2]==1">
                                                            <li class="list-group-item">ผ่ากอ</li>
                                                            <li class="list-group-item">ระเบิดดินดานระหว่างร่อง</li>
                                                            <li class="list-group-item">ใส่โดโลไมท์</li>
                                                            <li class="list-group-item">ใส่ปุ๋ยอินทรีย์</li>
                                                            <li class="list-group-item">ใส่ปุ๋ยเคมีตามความต้องการของอ้อย
                                                            </li>
                                                            <li class="list-group-item">ฉีดยาคุมแห้ง / กำจัดวัชพืช
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr />

                                            <!--<div class="form-group">
                                                <label for="exampleFormControlFile1"> file </label>
                                                <input mat-raised-button type="file" class="form-control-file"
                                                    id="exampleFormControlFile1" type="file"
                                                    accept=".pdf, .xls, .xlsx, .doc, .docx"
                                                    (change)="onFileSelected($event)">
                                                <a *ngIf="url_load" href={{url_load}} target="_blank">
                                                    -ไฟล์ที่อัพโหลด- <i class="fas fa-file-download nav-icon"></i>
                                                </a>
                                            </div>-->

                                            <div class="input-group mb-3">
                                                <span class="input-group-text">รายการที่เลือก</span>
                                                <textarea class="form-control" id="sumreason" [value]="typeSL[2]"
                                                    [disabled]="true"></textarea>
                                            </div>
                                            <div class="input-group mb-3">
                                                <span class="input-group-text">หมายเหตุ </span>
                                                <input type="text" class="form-control" id="anyreason"
                                                    placeholder="คำอธิบาย" [(ngModel)]="sel_landno.comment" required />
                                            </div>
                                            <div class="input-group mb-3">
                                                <span class="input-group-text">จำนวนเงิน</span>
                                                <input type="number" min="1.00" step="1.00" data-number-to-fixed="2"
                                                    class="form-control" id="countmoney" placeholder="0"
                                                    [(ngModel)]="sel_landno.count" required />
                                            </div>
                                            <div class="input-group mb-3" *ngIf="typeSL[3]=='e'">
                                                <span class="input-group-text">อัพโหลดไฟล์ สัญญาค่าเช่า</span>
                                                <input class="form-control" type="file" accept=".pdf, .doc, .docx"
                                                    (change)="onFileSelected($event)">
                                                <a *ngIf="url_load" href={{url_load}} target="_blank">
                                                    -ไฟล์ที่อัพโหลด- <i class="fas fa-file-download nav-icon"></i>
                                                </a>
                                            </div>
                                            <!--<input type="file" class="form-control" id="customFile" accept="image/png, image/jpeg" (change)="onFileUpload($event.target.files)"/>-->
                                            <!-- <label class="custom-file-label" for="customFile">เลือกไฟล์</label> -->
                                            <hr />
                                            <div class="float-left" *ngIf="sel_landno.itid != null">
                                                <button type="button" class="btn btn-primary"
                                                    *ngIf="sel_landno.typeD==1" (click)="gosave(1)"> <i
                                                        class="far fa-save"></i> บันทึก
                                                </button>
                                                <button type="button" class="btn btn-warning"
                                                    *ngIf="sel_landno.typeD==2" (click)="gosave(2)"> <i
                                                        class="far fa-save"></i> บันทึก
                                                </button>
                                                <!--<button type="button" class="btn btn-warning"
                                                    [disabled]="files_d == null" (click)="toUpload()"> <i
                                                        class="far fa-save"></i> toUpload
                                                </button>-->
                                            </div>
                                            <div class="float-right">
                                                <button class="btn btn-info float-right" (click)="cleartext()">
                                                    กรอกใหม่ </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- ฟอร์มขอเบิกสินเชื่อ -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ข้อมูลการขอสินเชื่อออนไลน์ปี 64/65 -->

        <div class="card">
            <div class="card-header bg-primary">
                <b>ข้อมูลการขอสินเชื่อออนไลน์ปี {{year[2]}}</b>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" (click)="getfinancebyzone2();"><i
                            class="fas fa-sync"></i></button>
                </div>
            </div>
            <div class="card-body">
                <table id="datatable" class="display" style="width:100%">

                </table>
                <!--
                <table #moneydata class="table table-sm table-striped table-hover table-head-fixed table-bordered">
                    <thead>
                        <tr>
                            <th>เลขที่</th>
                            <th>วันที่</th>
                            <th>ชื่อ</th>
                            <th>แปลง</th>
                            <th>ประเภทเกี้ยว</th>
                            <th>เหตุผล</th>
                            <th>จำนวนเงิน</th>
                            <th>สถานะ</th>
                            <th><i class="fas fa-ban"></i> ยกเลิก</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of datafinance" [ngClass]="item.over_limit == '1' ? 'bg-danger' : ''">
                            <td>{{ item.docid }}</td>
                            <td>{{ date2th(item.datepost) }}</td>
                            <td>{{ item.fmname }}</td>
                            <td>{{ item.intlandno }}</td>
                            <td>{{ item.type_money_sub }}</td>
                            <td>{{ item.comment1 }}</td>
                            <td>{{ item.money_amt | number }}</td>
                            <td>{{ item.docdesc }}</td>
                            
                            <td>

                                <button type="button" class="btn btn-outline-danger btn-sm" (click)="cancledoc_id(item)"
                                    *ngIf="item.doc_status == 0">
                                    <i class="fas fa-ban"></i> ยกเลิก</button>
                            </td>
                        </tr>
                    </tbody>
                </table>-->
            </div>
        </div>
        <!-- ข้อมูลการขอสินเชื่อออนไลน์ปี 64/65 -->
    </div>


    <div class="card" *ngIf="userdata.userlevel == '15'">
        <div class="card-header bg-primary">
            ข้อมูลการขอสินเชื่อออนไลน์ปี {{year[2]}}
            <b class="text-warning">เกินวงเงิน</b>
            <div class="card-tools">
                <button (click)="getfinancebyzone2()" type="button" class="btn btn-tool" title="รีเฟรซข้อมูล"><i
                        class="fas fa-sync-alt"></i></button>
                <!--<button type="button" class="btn btn-tool" data-card-widget="card-refresh" data-source="widgets.html" data-source-selector="#card-refresh-content" data-load-on-init="false"><i class="fas fa-sync-alt"></i></button>
                                <button type="button" class="btn btn-tool" data-card-widget="maximize"><i class="fas fa-expand"></i></button>
                                <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i></button>
                                <button type="button" class="btn btn-tool" data-card-widget="remove"><i class="fas fa-times"></i></button> -->
            </div>
        </div>
        <div class="card-body">
            <div id="loadingIndicator" style="display: none;">Loading...</div>
            <table id="datatable" class="display" style="width:100%">

            </table>
            <!--<table #moneydata class="table">
                <thead>
                    <tr>
                        <td>เลขที่</td>
                        <td>วันที่</td>
                        <td>ชื่อ</td>
                        <td>แปลง</td>
                        <td>ประเภทเกี้ยว</td>
                        <td>เหตุผล</td>
                        <td>จำนวนเงิน</td>
                        <td>สถานะ</td>
                        <td><i class="fas fa-bars"></i> Action</td>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of datafinance">
                        <td>{{ item.docid }}</td>
                        <td>{{ item.datepost | adtob }}</td>
                        <td>{{ item.fmname }}</td>
                        <td>{{ item.intlandno }}</td>
                        <td>{{ item.type_money_sub }}</td>
                        <td>{{ item.comment1 }}</td>
                        <td>{{ item.money_amt.toLocaleString() }}</td>
                        <td>{{ item.docdesc }}</td>
                        <td class="">
                            <button class="btn btn-sm btn-link" (click)="forwardtoFN(item)" *ngIf="item.doc_status == 2"
                                type="button" title="ส่งต่อสินเชื่อ">
                                <i class="fas fa-forward"></i>
                            </button>
                            <a [routerLink]="['/printaskformoney']" routerLinkActive="active" target="_blank">
                                
                            </a>
                            
                            <button type="button" class="btn btn-sm btn-outline-danger" (click)="cancledoc_id(item)"
                                *ngIf="item.doc_status == 2 || item.doc_status == 0" title="ยกเลิกเกี้ยว">
                                <i class="fa fa-close"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        -->
        </div>
        <!-- ข้อมูลการขอสินเชื่อออนไลน์ปี 64/65 -->
    </div>
</div>


<!-- Modal  -->
<div class="modal fade" id="forwardtofn" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <form class="needs-validation" #frm_forwardfn="ngForm">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header bg-primary">
                    <h1><mat-icon>forward</mat-icon> ส่งต่อเกี้ยวไปสินเชื่อ</h1>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row mt-1">
                        <blockquote class="blockquote">
                            <p class="text-primary">{{ valuesTomodal[3] }}</p>
                            <footer class="blockquote-footer">เลขที่คำขอ {{ valuesTomodal[0] }}
                                เมื่อ {{ valuesTomodal[4]|adtob }}</footer>
                        </blockquote>
                    </div>

                    <input type="hidden" #e_docid="ngModel" ngModel name="e_docid" id="e_docid"
                        [(ngModel)]="valuesTomodal[0]" readonly required>

                    <div class="row mt-1">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">จำนวนเงินที่ขอ </span>
                            </div>
                            <input #e_money_amt="ngModel" ngModel name="e_money_amt" id="e_money_amt"
                                class="form-control"
                                [ngClass]="{ 'is-invalid' : e_money_amt.invalid && (e_money_amt.dirty || e_money_amt.touched)}"
                                type="number" [(ngModel)]="valuesTomodal[1]" required>

                            <div class="invalid-feedback">
                                <span *ngIf="e_money_amt.hasError('required')">กรุณากรอกจำนวนเงินที่ขอ</span>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-1">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">เหตุผลการขอเกี้ยว </span>
                            </div>
                            <input #e_comment1="ngModel" ngModel name="e_comment1" id="e_comment1" class="form-control"
                                [ngClass]="{ 'is-invalid' : e_comment1.invalid && (e_comment1.dirty || e_comment1.touched)}"
                                type="text" [(ngModel)]="valuesTomodal[2]" required>
                            <div class="invalid-feedback">
                                <span *ngIf="e_comment1.hasError('required')">กรุณากรอกจำนวนเงินที่ขอ</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button (click)="saveforwardtoFN(frm_forwardfn.value)" [disabled]="frm_forwardfn.invalid"
                        type="submit" class="btn btn-outline-success" data-dismiss="modal">
                        <i class="fas fa-save"></i> Save
                    </button>
                    <button type="button" class="btn btn-outline-warning" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </form>
</div>

<!-- MOdal -->
<app-footer></app-footer>